import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import { useAdvancedOverviewState } from '../../../api/AdvancedOverviewProvider'
import { useTrackCatalog } from '../../../api/useTrackCatalog'
import { trackTitle } from '../../../dashboard/tracks/trackTransitions'
import { SELECT_MENU_PROPS } from '../../fieldPrimitives'

// Names the track this intake note is for, which is what lets that track be accepted (ADR-097).
const IntakeTrackSelect = ({ value, onChange }: { value: string; onChange: (trackKey: string) => void }) => {
  const overview = useAdvancedOverviewState()
  const catalog = useTrackCatalog()
  const inIntake =
    overview.status === 'ready'
      ? overview.overview.summary.tracks.filter((track) => track.stage === 'intake' && !track.endedAt)
      : []

  return (
    <TextField
      select
      size="small"
      fullWidth
      label="Intake for track"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      helperText={inIntake.length === 0 ? 'No track is waiting for its intake.' : undefined}
      SelectProps={{ MenuProps: SELECT_MENU_PROPS }}
    >
      <MenuItem value="">None</MenuItem>
      {inIntake.map((track) => (
        <MenuItem key={track.enrollmentId} value={track.trackKey}>
          {trackTitle(catalog, track.trackKey)}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default IntakeTrackSelect
